import { useState } from "react";
import { Helmet } from "react-helmet";
import logo from "../images/logo_horizontal.svg";
import loader from "../images/loader.gif";

// Context
import { useAuth } from "../context/useAuth";
import { useNavigate } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";

export default function Submit() {
  let { login, showNetworkError, setShowNetworkError, isConnecting } = useAuth();
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  const loginFn = async (credentialResponse) => {
    if (!(await login(credentialResponse))) {
      setError(true);
    } else {
      navigate("/");
    }
  };

  if (showNetworkError) {
    return (
      <div className="login-container">
        <img className="login-logo" src={logo} alt="Logo"></img>

        <div className="login-form">
          <div className="alert-error mt-15">Network error</div>
          <button className=" mt-15" onClick={() => setShowNetworkError(false)}>
            Refresh
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>The BOS</title>
      </Helmet>

      <div className="login-container">
        <div className="login-logo logo-wrapper">
          <img className="logo-img" src={logo} alt="Logo"></img>
          <div className="logo-text">Business Operating System</div>
        </div>

        <div className={`login-form ${isConnecting ? "connecting" : ""}`}>
          <div className="loading-spinner">
            <div className="loader">
              <img alt="loader" src={loader}></img>
              <div>Connecting ...</div>
            </div>
          </div>

          <div className="login-btn">
            <GoogleLogin
              onSuccess={(credentialResponse) => {
                loginFn(credentialResponse);
              }}
              onError={() => {
                console.warn("Login Failed");
              }}
            />
          </div>
        </div>

        {error && <div className="alert-error mt-30">Login not valid</div>}
      </div>
    </>
  );
}
